module.exports = __webpack_public_path__ + "static/img/badge-trap-active-irregular.fd4f12f.svg";